/******/ (() => { // webpackBootstrap
class ScrollingBanner extends HTMLElement {
  constructor() {
    super();
    this.duplicatedLinks = this.querySelectorAll('ol[data-duplicated] a');
    this.banners = Array.from(this.querySelectorAll('.banner'));
    this.parallaxFrame = null;
    this.parallaxCurrent = 0;
    this.parallaxTarget = 0;
    this.lastScrollY = window.scrollY;

    this.handleIntersection = this.handleIntersection.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.updateParallax = this.updateParallax.bind(this);
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
    this.parallaxObserver?.disconnect();
    cancelAnimationFrame(this.parallaxFrame);
  }

  init() {
    this.duplicatedLinks.forEach(link => {
      link.setAttribute('tabindex', '-1'); //prevents focusing on a duplicated link on keyboard nav
    });

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (this.dataset.parallax !== 'true' || reducedMotion || !('IntersectionObserver' in window)) return;

    this.parallaxStrength = (Number.parseFloat(this.dataset.parallaxStrength) || 1.5) * 4;
    this.parallaxObserver = new IntersectionObserver(this.handleIntersection, {
      rootMargin: '100px 0px',
      threshold: 0,
    });
    this.parallaxObserver.observe(this);
  }

  handleIntersection(entries) {
    if (entries[0]?.isIntersecting) {
      this.lastScrollY = window.scrollY;
      this.parallaxCurrent = 0;
      this.parallaxTarget = 0;
      window.addEventListener('scroll', this.handleScroll, { passive: true });
    } else {
      window.removeEventListener('scroll', this.handleScroll);
      cancelAnimationFrame(this.parallaxFrame);
      this.parallaxFrame = null;
    }
  }

  handleScroll() {
    const scrollY = window.scrollY;
    this.parallaxTarget += (scrollY - this.lastScrollY) * this.parallaxStrength;
    this.lastScrollY = scrollY;

    if (!this.parallaxFrame) this.parallaxFrame = requestAnimationFrame(this.updateParallax);
  }

  updateParallax() {
    const difference = this.parallaxTarget - this.parallaxCurrent;
    const isSettled = Math.abs(difference) < 0.25;
    const timeShift = isSettled
      ? difference
      : Math.sign(difference) * Math.min(Math.abs(difference) * 0.14, 72);

    this.parallaxCurrent += timeShift;

    this.banners.forEach(banner => {
      banner.getAnimations().forEach(animation => {
        const currentTime = Number(animation.currentTime);
        const duration = Number(animation.effect?.getTiming().duration);
        if (!Number.isFinite(currentTime) || !Number.isFinite(duration) || duration <= 0) return;

        animation.currentTime = ((currentTime + timeShift) % duration + duration) % duration;
      });
    });

    this.parallaxFrame = isSettled ? null : requestAnimationFrame(this.updateParallax);
  }

}

// Only define the custom element if it doesn't already exist
if (!customElements.get('scrolling-banner')) customElements.define('scrolling-banner', ScrollingBanner);

/******/ })()
;
